import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AppDrawerContainer from "./AppDrawerContainer";
import AccountUrlResolverContainer from "./AccountUrlResolverContainer";
import NoMatch from "./NoMatch";
import Accounts from "./Accounts";
import SnackbarContainer from "./SnackbarContainer";
import InfoDialogContainer from "./InfoDialogContainer";
import EditUserDialogContainer from "./EditUserDialogContainer";
import CreateInvoiceDialogContainer from "./CreateInvoiceDialogContainer";
import OvUrlResolverContainer from "./OvUrlResolverContainer";
import EditCostLimitDialogContainer from "./EditCostLimitDialogContainer";
import EditAccountSettingsDialogContainer from "./EditAccountSettingsDialogContainer";

/*
1. Put all pages that will need their own URL in the router's switch statement.

2. Put modals, forms, snakbars etc. as hidden components that (listen) to the 
store in order to know when to display themselves. They have no URL.
*/

const TopLevelRouter = (props, context) => {
  return (
    <Router>
      <div>
        <Switch>
          <Route
            exact
            path="/"
            render={routerProps => <Accounts {...routerProps} />}
          />
          <Route
            exact
            path="/accounts"
            render={routerProps => <Accounts {...routerProps} />}
          />
          <Route
            path="/overview"
            render={routerProps => <OvUrlResolverContainer {...routerProps} />}
          />
          <Route
            path={`/accounts/:accountId`}
            render={routerProps => (
              <AccountUrlResolverContainer {...routerProps} />
            )}
          />
          <Route render={routerProps => <NoMatch {...routerProps} />} />
        </Switch>

        <AppDrawerContainer {...props} />
        <SnackbarContainer />
        <InfoDialogContainer />
        <EditUserDialogContainer />
        <EditCostLimitDialogContainer />
        <EditAccountSettingsDialogContainer />
        <CreateInvoiceDialogContainer />
      </div>
    </Router>
  );
};

export default TopLevelRouter;



// WEBPACK FOOTER //
// ./src/TopLevelRouter.js